import React from 'react'
import { DeleteTimeClockFlowProvider } from './context/DeleteTimeClockFlowProvider'
import { DeleteTimeClockFlowMain } from './components/DeleteTimeClockFlowMain'
import { useTimeClocksWorkflowsContextValue } from '../../context/TimeClocksWorkflowsProvider'

export const DeleteTimeClockFlow = () => {
  const { deleteTimeClockFlow } = useTimeClocksWorkflowsContextValue()

  if (!deleteTimeClockFlow.timeClock) {
    return null
  }

  return (
    <DeleteTimeClockFlowProvider>
      <DeleteTimeClockFlowMain timeClock={deleteTimeClockFlow.timeClock} />
    </DeleteTimeClockFlowProvider>
  )
}
